import { Divider } from "@omni/ui/components/Divider/divider.component";
import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { CTAListRenditions } from "@/components/Product/ProductImage/mappedRenditions";
import { ProductImageContainer } from "@/components/Product/ProductImage/productImage.container";
import {
    CTAActions,
    ProductCallToAction
} from "@/redux/modules/api/data/cart/@types/cart.types";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

type Props = {
    cta: ProductCallToAction;
    activatedAction?: CTAActions;
};

const List = ({ cta, activatedAction }: Props) => {
    const { messages } = useCallToActionsContext();
    const product = cta.product;

    return (
        <>
            {product && (
                <>
                    <Divider className={cn("mb-3")} />
                    <Row>
                        <Col xs={"auto"}>
                            <ProductImageContainer
                                title={product.title}
                                medias={product.medias}
                                isEcoChequesAccepted={false}
                                className={cn("tw:w-16!")}
                                renditions={CTAListRenditions}
                            />
                        </Col>
                        <Col
                            xs={8}
                            className="d-flex align-items-center"
                        >
                            <p className="m-0">{product.title}</p>
                        </Col>
                    </Row>
                    <Divider />
                </>
            )}
            {messages.map((m) => (
                <p key={m.key}>{m.message}</p>
            ))}
            {cta.actions.length > 1 &&
                cta.actions.map((a) => a.visual?.(cta.product, a))}
            {!activatedAction?.isExtended &&
                activatedAction?.action &&
                activatedAction?.action(cta.product, activatedAction)}
        </>
    );
};

export default List;
